import { render } from "./XeroSettingsView.vue?vue&type=template&id=7933644d&scoped=true"
import script from "./XeroSettingsView.vue?vue&type=script&lang=js"
export * from "./XeroSettingsView.vue?vue&type=script&lang=js"

import "./XeroSettingsView.vue?vue&type=style&index=0&id=7933644d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7933644d"]])

export default __exports__